import store from '../store';
import constants from '../constants';

import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout.vue';
import AuthLayout from '@/pages/Dashboard/Pages/AuthLayout.vue';
import AuthLayoutNew from '@/pages/Dashboard/Pages/AuthLayoutNew.vue';
import StaticPageLayout from '@/pages/Dashboard/Pages/StaticPageLayout.vue';

// Dashboard pages
import Dashboard from '@/pages/Dashboard/Dashboard.vue';
import DashboardOld from '@/pages/Dashboard/DashboardOld.vue';
import EBSRCM from '@/pages/Dashboard/EBSRCM.vue';
import AuditTrail from '@/pages/Dashboard/AuditTrail.vue';
// import EstimateDetails from '@/pages/Dashboard/Pages/PayeEstimates/EstimateDetails.vue';
// src\pages\Dashboard\Pages\PayeEstimates\EstimateDetails.vue

// Homepage
const Home = () => import('@/pages/index.vue');

// TCC Verification
const VerifyTcc = () => import('@/pages/Dashboard/Pages/TCC/VerifyTcc.vue');

const Tcc = () => import('@/pages/Dashboard/Pages/TCC/Tcc.vue');

// Admin Auth
// const Login = () => import('@/pages/Dashboard/Pages/Login.vue');
const LoginNew = () => import('@/pages/Dashboard/Pages/LoginNew.vue');

// Tax Offices
const TaxOffices = () =>
  import('@/pages/Dashboard/Pages/TaxOffices/TaxOffices.vue');

// Tax Services
const TaxServices = () =>
  import('@/pages/Dashboard/Pages/TaxServices/TaxServices.vue');

  //User Tax Offices


//Users
const UserManagement = () =>
  import('@/pages/Dashboard/Pages/UserManagement/UserManagement.vue');
const AdminProfile = () => import('@/pages/Dashboard/AdminProfile.vue');

//Admin Tools
const AdminTools = () =>
  import('@/pages/Dashboard/Pages/AdminTools/AdminTools.vue');

//Workflows
// const WorkFlows = () =>
//   import("@/pages/Dashboard/Pages/WorkFlows/WorkFlows.vue");
// const WorkFlow = () => import("@/pages/Dashboard/Pages/WorkFlows/WorkFlow.vue");

// Consultants
// const ConsultantLogin = () =>
//   import('@/pages/Dashboard/Pages/ConsultantArea/ConsultantLogin.vue');
const ConsultantLoginNew = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/ConsultantLoginNew.vue');

const ConsultantsList = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/Consultants.vue');

const ConsultantTamaJobRequests = () =>
  import('@/pages/Dashboard/Pages/ConsultantTamaJobRequests/List.vue');

const BulkConsultantsUpload = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/BulkConsultantsUpload.vue');

const ConsultantTamaUsers = () =>
  import('@/pages/Dashboard/Pages/Consultants/Users.vue');

//Relationship Management Unit (RMU)
const RelationshipManagementUnit = () =>
  import(
    '@/pages/Dashboard/Pages/RelationshipManagementUnit/RelationshipManagementUnit.vue'
  );

//High Networth
const HighNetWorth = () =>
  import('@/pages/Dashboard/Pages/HighNetWorth/HighNetWorth.vue');

//Roles and Permissions
const RoleManagement = () =>
  import('@/pages/Dashboard/Pages/RoleManagement/RoleManagement.vue');
const RolePermissions = () =>
  import('@/pages/Dashboard/Pages/RoleManagement/Permissions.vue');

// Audits
const TaxAuditCases = () => import('@/pages/Dashboard/Pages/Audits/Cases.vue');
const TaxAuditCaseDetail = () =>
  import('@/pages/Dashboard/Pages/Audits/CaseDetail.vue');
const AssignedAuditCases = () => import('@/pages/Dashboard/Pages/Audits/AssignedAuditCases.vue');
const AuditCaseActivityView = () =>
  import('@/pages/Dashboard/Pages/Audits/AuditCaseActivityView.vue');
const TaxAuditTeam = () => import('@/pages/Dashboard/Pages/Audits/Team.vue');
const TaxAuditTeamDetails = () =>
  import('@/pages/Dashboard/Pages/Audits/TeamDetail.vue');
const TaxAuditTeamOverview = () =>
  import('@/pages/Dashboard/Pages/Audits/TeamOverview.vue');
const TaxAuditObjections = () =>
  import('@/pages/Dashboard/Pages/Audits/Objections.vue');
const AssignedObjections = () =>
  import('@/pages/Dashboard/Pages/Audits/AssignedObjections.vue');
const ObjectionActivityView = () =>
  import('@/pages/Dashboard/Pages/Audits/ObjectionActivityView.vue');
const ObjectionSummaryView = () =>
  import('@/pages/Dashboard/Pages/Audits/ObjectionSummaryView.vue');

const LaspppaRequests = () =>
  import('@/pages/Dashboard/Pages/Laspppa/Requests.vue');
const LaspppaRequest = () =>
  import('@/pages/Dashboard/Pages/Laspppa/Request.vue');
const LaspppaNewRequest = () =>
  import('@/pages/Dashboard/Pages/Laspppa/NewRequest.vue');

//Tax Payers
const IndividualTaxPayers = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/Individual.vue');

const IndividualTaxPayersUnactivated = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/IndividualUnactivated.vue');
const BulkIndividualRegistrations = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/BulkIndividualRegistrations.vue');
const CorporateTaxPayers = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/Corporate.vue');
const CorporateTaxPayersUnactivated = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/CorporateUnactivated.vue');
const NewCorporatePayer = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/NewCorporatePayer.vue');
const NewIndividualPayer = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/NewIndividualPayer.vue');

const IndividualPayerProfilePage = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/IndividualProfilePageNew.vue'); // BACKUP: IndividualProfilePage.vue
const CorporatePayerProfilePage = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/CorporateProfilePageNew.vue'); // BACKUP: CorporateProfilePage.vue
const CorporatePayerReturnsPage = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/CorporatePayerReturnsPage.vue');
const NewAssessment = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/NewAssessment.vue');
const Assessment = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/Assessment.vue');
const AssessmentSummary = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/AssessmentSummary.vue');
const AssessmentSummaryIndividual = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/AssessmentSummaryIndividual.vue');
const Payroll = () => import('@/pages/Dashboard/Pages/TaxPayers/Payroll.vue');
const TaxPayerVerification = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/Verification.vue');
// Advaced Tax Payer Update
const AdvancedTaxPayer = () =>
  import('@/pages/Dashboard/Pages/TaxPayers/AdvancedTaxPayer.vue');

// Payments
const Payment = () => import('@/pages/Dashboard/Pages/Payments/Payment.vue');


// Reports
const Debts = () => import('@/pages/Dashboard/Pages/Reports/Debts.vue');
const IndividualReport = () =>
  import('@/pages/Dashboard/Pages/Reports/IndividualTaxPayers.vue');
const CorporateReport = () =>
  import('@/pages/Dashboard/Pages/Reports/CorporateTaxPayers.vue');
const DirectorReport = () =>
  import('@/pages/Dashboard/Pages/Reports/Directors.vue');
const ReturnsReport = () =>
  import('@/pages/Dashboard/Pages/Reports/Returns.vue');
const HorcReturnsReport = () =>
  import('@/pages/Dashboard/Pages/Reports/HorcReturns.vue');
const ReturnsAdequacyChecks = () =>
  import('@/pages/Dashboard/Pages/Reports/AdequacyChecks.vue');
const AssessmentReport = () =>
  import('@/pages/Dashboard/Pages/Reports/Assessment.vue');
const TaxAuditReport = () =>
  import('@/pages/Dashboard/Pages/Reports/TaxAudit.vue');
const RevenueReport = () =>
  import('@/pages/Dashboard/Pages/Reports/Revenue.vue');
const EbsTransactionsReport = () =>
  import('@/pages/Dashboard/Pages/Reports/EbsTransactionsReport.vue');
const EbsExpatriatesReport = () =>
  import('@/pages/Dashboard/Pages/Reports/EbsExpatriatesReport.vue');
const EbsTrendCollectionReport = () =>
  import('@/pages/Dashboard/Pages/Reports/EbsTrendCollectionReport.vue');
const BillsReport = () =>
  import('@/pages/Dashboard/Pages/Reports/Bills.vue');
const RmuRevenueReport = () =>
  import('@/pages/Dashboard/Pages/Reports/RmuRevenue.vue');
const CorporatePayeEstimateRecords = () =>
  import('@/pages/Dashboard/Pages/PayeEstimates/CorporatePayeEstimateRecords.vue');
const CorporatePayeRecordEstimates = () =>
  import('@/pages/Dashboard/Pages/PayeEstimates/CorporatePayeRecordEstimates.vue');

const EstimateDetails = () =>
  import('@/pages/Dashboard/Pages/PayeEstimates/EstimateDetails.vue');


//  Messages
const DirectMessages = () => import('@/pages/Dashboard/Pages/Messages/DirectMessages.vue');
const BulkMessages = () => import('@/pages/Dashboard/Pages/Messages/BulkMessages.vue');

/* START USER AREA ROUTES  */

// Privacy Policy
const privacyPolicy = () =>
  import('@/pages/Dashboard/Pages/StaticPages/privacyPolicy.vue');

// USER AUTH
const userSignUp = () =>
  import('@/pages/Dashboard/Pages/UserArea/userSignUp.vue');
const forgotPassword = () =>
  import('@/pages/Dashboard/Pages/UserArea/forgotPassword.vue');
const forgotTaxId = () =>
  import('@/pages/Dashboard/Pages/UserArea/forgotTaxId.vue');
const userRegister = () =>
  import('@/pages/Dashboard/Pages/UserArea/userRegister.vue');
const userSignUpSecondStep = () =>
  import('@/pages/Dashboard/Pages/UserArea/userSignUpSecondStep.vue');
const userSignUpThirdStep = () =>
  import('@/pages/Dashboard/Pages/UserArea/userSignUpThirdStep.vue');

const corporateUserSignUpThirdStep = () =>
  import('@/pages/Dashboard/Pages/UserArea/corporateUserSignUpThirdStep.vue');

const userSignUpOtpStep = () =>
  import('@/pages/Dashboard/Pages/UserArea/userUpdatePassword.vue');
// const userLogin = () =>
//   import('@/pages/Dashboard/Pages/UserArea/userLogin.vue');
const userLoginNew = () =>
  import('@/pages/Dashboard/Pages/UserArea/userLoginNew.vue');
const userLoginCorporateAdminNew = () =>
  import('@/pages/Dashboard/Pages/UserArea/userLoginCorporateAdminNew.vue');
const GeoTagging = () =>
  import('@/pages/Dashboard/Pages/Geo/GeoTagging.vue');
const AssessmentRequests = () =>
  import('@/pages/Dashboard/Pages/AssessmentRequests/RequestsList.vue');

// CONSULTANT DASHBOARD
const consultantDashboardLayout = () =>
  import(
    '@/pages/Dashboard/Pages/ConsultantArea/consultantDashboardLayout.vue'
  );
const consultantDashboard = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/consultantDashboard.vue');
const consultantMemberListView = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/MemberListView.vue');
const consultantCasesListView = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/CasesListView.vue');

const consultantPayersList = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/consultantPayersList.vue');

const consultantRequestsList = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/consultantRequests.vue');

const AssignedCases = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/assignedCases.vue');

const TamaJobRequests = () =>
  import('@/pages/Dashboard/Pages/ConsultantArea/TamaJobRequests/List.vue');

const PayeEstimateRecords = () =>
  import('@/pages/Dashboard/Pages/UserArea/PayeEstimates/PayeEstimateRecords.vue');
const PayeRecordEstimates = () =>
  import('@/pages/Dashboard/Pages/UserArea/PayeEstimates/PayeRecordEstimates.vue');

// USER DASHBOARD
const userDashboardLayout = () =>
  import('@/pages/Dashboard/Pages/UserArea/userDashboardLayout.vue');
// const userDashboard = () =>
//   import('@/pages/Dashboard/Pages/UserArea/userDashboard.vue');

// USER PROFILE
const userIndividualProfile = () =>
  import('@/pages/Dashboard/Pages/UserArea/userIndividualProfile.vue');
const userCorporateProfile = () =>
  import('@/pages/Dashboard/Pages/UserArea/userCorporateProfile.vue');

  const MyStation = () =>
  import('@/pages/Dashboard/Pages/UserArea/myStation.vue');

// USER ASSEMENTS
const userAssements = () =>
  import('@/pages/Dashboard/Pages/UserArea/assesment/userAssesments.vue');
const userAssementsNew = () =>
  import('@/pages/Dashboard/Pages/UserArea/assesment/userAssementsNew.vue');

const taxCalculator = () =>
  import('@/pages/Dashboard/Pages/UserArea/assesment/taxCalculator.vue');

// PAYMENTS
const generatePayBill = () =>
  import('@/pages/Dashboard/Pages/UserArea/payment/generatePayBill.vue');
const userPaymentHistory = () =>
  import('@/pages/Dashboard/Pages/UserArea/payment/userPaymentHistory.vue');
const PaymentChannel = () =>
  import('@/pages/Dashboard/Pages/UserArea/payment/PaymentChannel.vue');


// RETURNS
const userReturns = () =>
  import('@/pages/Dashboard/Pages/UserArea/userReturns.vue');
const horcReturns = () =>
  import('@/pages/Dashboard/Pages/UserArea/userHorcReturns.vue');

const annualReturns = () =>
  import('@/pages/Dashboard/Pages/Returns/Individual/AnnualReturns.vue');
const AdequacyCheck = () =>
  import('@/pages/Dashboard/Pages/Returns/Corporate/AdequacyCheck.vue');

// AUDITS
const userAudit = () =>
  import('@/pages/Dashboard/Pages/UserArea/userAudit.vue');

const requestsToConsultants = () =>
  import('@/pages/Dashboard/Pages/UserArea/requestsToConsultants.vue');

// Tax Payer Merge
const MergeRequests = () =>
  import('@/pages/Dashboard/Pages/MergeRequests/MergeRequests.vue');
const MergeRequest = () =>
  import('@/pages/Dashboard/Pages/MergeRequests/MergeRequest.vue');
const MergeRequestForm = () =>
  import('@/pages/Dashboard/Pages/MergeRequests/MergeRequestForm.vue');

const AddressChangeRequests = () =>
  import('@/pages/Dashboard/Pages/AddressChangeRequests/List.vue');

const AddressChangeRequestReview = () =>
  import('@/pages/Dashboard/Pages/AddressChangeRequests/Show.vue');

const TamRequestForm = () =>
  import('@/pages/Dashboard/Pages/TAMA/RequestForm.vue');

// Tama Requests
const TamaRequests = () =>
  import('@/pages/Dashboard/Pages/TamaRequests/Index.vue');
const TamaRequest = () =>
  import('@/pages/Dashboard/Pages/TamaRequests/Request.vue');

// Corporate Admin Settings
const CorporateAdminSettings = () => import("@/pages/Dashboard/Pages/TaxPayers/CorporateAdminSettings.vue");
const CorporateAdmins = () => import('@/pages/Dashboard/Pages/UserArea/CorporateAdmins.vue');

// Taxpayer Status Update
// Tax Services
const TaxpayerStatusUpdate = () =>
  import('@/pages/Dashboard/Pages/TaxpayerStatusUpdate/TaxpayerStatusUpdate.vue');

let validateAdminRoutes = function(to, from, next) {
  store.state.auth &&
  store.state.auth.userData &&
  store.state.auth.userData.user &&
  store.state.auth.userData.user.role_id
    ? next()
    : next({
        path: '/admin/login'
      });
};

let validateUserRoutes = function(to, from, next) {
  store.state.auth &&
  store.state.auth.userData &&
  store.state.auth.userData.user &&
  store.state.auth.userData.user.entity_type_object
    ? next()
    : next({
      path: '/login'
    });
};

let validateConsultantRoutes = function(to, from, next) {
  store.state.auth &&
  store.state.auth.userData &&
  store.state.auth.userData.user &&
  store.state.auth.userData.user.role_id
    ? next()
    : next({
        path: '/consultant/login'
      });
};

let checkPermissions = (to, from, next, allowed_perms, nested = false) => {
  if (constants.userCan(allowed_perms)) {
    next();
  }
  if(nested && constants.hasNestedAccess(allowed_perms)) {
    next();
  }
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/',
    redirect: 'home',
    name: constants.login.payer,
    component: AuthLayout,
    children: [
      {
        path: '/signup',
        name: 'Sign Up',
        components: {
          default: userSignUp
        }
      },
      {
        path: '/forgot-password',
        name: 'Forgot Password',
        components: {
          default: forgotPassword
        }
      },
      {
        path: '/register',
        name: 'Register fresh user',
        components: {
          default: userRegister
        }
      },
      {
        path: '/signup/next',
        name: 'Sign Up - Step 2',
        components: {
          default: userSignUpSecondStep
        }
      },
      {
        path: '/signup/step3',
        name: 'Sign Up - Step 3',
        components: {
          default: userSignUpThirdStep
        }
      },
      {
        path: '/signup/corporate-step3',
        name: 'Sign Up(Corporate) - Step 3',
        components: {
          default: corporateUserSignUpThirdStep
        }
      },
      {
        path: '/signup/otp',
        name: 'signup-otp',
        components: {
          default: userSignUpOtpStep
        }
      },
      // {
      //   path: '/login',
      //   name: constants.login.payer,
      //   components: {
      //     default: userLogin
      //   }
      // },
      {
        path: '/forgot-taxid',
        name: `Forgot ${constants.identityLabels.ebs}`,
        components: {
          default: forgotTaxId
        }
      },
      {
        path: '/tccverification',
        name: 'tccverification',
        components: {
          default: VerifyTcc
        }
      }
    ]
  },

  // Taxpayers Login with New Layout
  {
    path: '/',
    redirect: 'home',
    name: constants.login.payer,
    component: AuthLayoutNew,
    children: [
      {
        path: '/login',
        name: constants.login.payer,
        components: {
          default: userLoginNew
        }
      }
    ]
  },

  // Corporate Admin Login with New Layout
  {
    path: '/corporate-admin',
    redirect: '/corporate-admin/login',
    name: constants.login.payer,
    component: AuthLayoutNew,
    children: [
      {
        path: '/corporate-admin/login',
        name: constants.login.payer,
        components: {
          default: userLoginCorporateAdminNew
        }
      }
    ]
  },
  {
    path: '/admin',
    redirect: '/admin/login',
    name: constants.login.admin,
    component: AuthLayout,
    children: [
      // {
      //   path: '/admin/login',
      //   name: constants.login.admin,
      //   component: Login
      // },
      {
        path: '/admin/reset-password',
        name: 'Reset Admin Password',
        component: userSignUp
      },
      {
        path: '/admin/otp',
        name: 'Admin OTP',
        component: userSignUpOtpStep
      }
      // {
      //   path: '/forgot-password',
      //   name: 'Forgot Password',
      //   component: Lock
      // }
    ]
  },
  // Admin Login with New Layout
  {
    path: '/admin',
    redirect: '/admin/login',
    name: constants.login.admin,
    component: AuthLayoutNew,
    children: [
      {
        path: '/admin/login',
        name: constants.login.admin,
        component: LoginNew
      }
    ]
  },
  {
    path: '/consultant',
    redirect: '/consultant/login',
    name: constants.login.consultant,
    // component: AuthLayout,
    component: AuthLayoutNew,
    children: [
      {
        path: '/consultant/login',
        name: constants.login.consultant,
        component: ConsultantLoginNew
      }
    ]
  },
  {
    path: '/consultant',
    redirect: '/consultant/dashboard',
    name: 'Consultant Dashboard Layout',
    component: consultantDashboardLayout,
    children: [
      {
        path: 'dashboard',
        name: 'Consultant Dashboard',
        components: {
          default: consultantDashboard
        }
      },
      {
        path: 'users',
        name: 'Consultant Users',
        components: {
          default: consultantMemberListView
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultantusers',
            'consultant.getoneconsultantuser'
          ]);
        }
      },
      {
        path: 'cases',
        name: 'Consultant Cases',
        components: {
          default: consultantCasesListView
        }
      },
      {
        path: 'tax-payers',
        name: 'Consultant Payers',
        components: {
          default: consultantPayersList
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultanttaxpayers'
          ]);
        }
      },
      {
        path: 'my-tax-payers',
        name: 'My Assigned Tax Payers',
        components: {
          default: consultantPayersList
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultanttaxpayers'
          ]);
        }
      },
      {
        path: 'payer-requests',
        name: 'Consultant Requests',
        components: {
          default: consultantRequestsList
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallrequests'
          ]);
        }
      },
      {
        path: 'tax-audits-cases',
        name: 'Assigned Cases',
        components: {
          default: AssignedCases
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getall',
            'default'
          ], true);
        }
      },
      {
        path: 'tax-audits-cases/:id',
        name: 'Tax Audit Case Detail',
        components: {
          default: TaxAuditCaseDetail
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getone'
          ]);
        }
      },

      {
        path: 'assigned-audit-cases',
        name: 'Assigned Audit Cases',
        components: {
          default: AssignedAuditCases
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getall',
            'assigned'
          ], true);
        }
      },

      {
        path: 'audit-case-activities/:id',
        name: 'Audit Case Activities',
        components: {
          default: AuditCaseActivityView
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getone'
          ]);
        }
      },
      {
        path: 'tax-payers/individual/:id/assessment/:assessment_id',
        name: 'Assessment - Individual',
        components: {
          default: Assessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.getoneassessmentgroup'
          ]);
        }
      },
      {
        path: 'tama-job-requests',
        name: 'TAMA Job Requests',
        components: {
          default: TamaJobRequests
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallrequests'
          ]);
        }
      },
    ],
    beforeEnter: (to, from, next) => {
      validateConsultantRoutes(to, from, next);
    }
  },
  {
    path: '/user',
    redirect: '/user/profile',
    name: 'User Dashboard Layout',
    component: userDashboardLayout,
    children: [
      // {
      //   path: 'dashboard',
      //   name: 'User Dashboard',
      //   components: {
      //     default: userDashboard
      //   }
      // },
      {
        path: 'profile',
        name: 'User Profile',
        components: {
          default: userIndividualProfile
        }
      },
      {
        path: 'messages',
        name: 'Messages',
        components: {
          default: DirectMessages
        }
      },
      {
        path: 'MyStation',
        name: 'My Station',
        components: {
          default: MyStation
        }
      },
      {
        path: 'merge-requests',
        name: 'Accounts Merge',
        components: {
          default: MergeRequests
        }
      },
      {
        path: 'merge-requests/new',
        name: 'Accounts Merge Request',
        components: {
          default: MergeRequestForm
        },
        meta: { enableBack: true }
      },
      {
        path: 'payroll/:id/:payroll_id',
        name: 'Corporate Payroll - Taxpayer',
        components: {
          default: Payroll
        },
        meta: { enableBack: true }
      },
      {
        path: 'corporate/profile/:id',
        name: 'User Corporate Profile',
        components: {
          default: userCorporateProfile
        },
        meta: { enableBack: true }
      },
      {
        path: 'assessments',
        name: 'User Assessment',
        components: {
          default: userAssements
        }
      },
      {
        path: 'assessments/tax-calculator',
        name: 'Tax Calculator',
        components: {
          default: taxCalculator
        }
      },
      {
        path: 'assessments/detail/:assessment_id',
        name: 'User Assessment Detail',
        components: {
          default: Assessment
        },
        meta: { enableBack: true }
      },
      {
        path: 'assessment/new',
        name: 'New Assessment - User',
        components: {
          default: userAssementsNew
        }
      },
      {
        path: 'payments/bill',
        name: 'Generate/Pay Bill',
        components: {
          default: generatePayBill
        }
      },
      {
        path: 'payments/history',
        name: 'Payment History',
        components: {
          default: userPaymentHistory
        }
      },
      {
        path: 'payment/channel/:currency_id',
        name: 'Payment Channel',
        components: {
          default: PaymentChannel
        }
      },
      {
        path: 'returns',
        name: 'Returns',
        components: {
          default: userReturns
        }
      },
      {
        path: 'horc-returns',
        name: 'Horc Returns',
        components: {
          default: horcReturns
        }
      },
      {
        path: 'annual-returns',
        name: 'Employer-Filed Returns',
        components: {
          default: annualReturns
        }
      },
      {
        path: 'corporate/:id/returns/:returnsId/:returnType',
        components: {
          default: CorporatePayerReturnsPage
        }
      },
      {
        path: 'audit',
        name: 'Audit',
        components: {
          default: userAudit
        }
      },
      {
        path: 'consultant-requests',
        name: 'Consultants Requests',
        components: {
          default: requestsToConsultants
        }
      },
      {
        path: 'objections',
        name: 'Objections',
        components: {
          default: TaxAuditObjections
        }
      },
      {
        path: 'objections/:id',
        name: 'Objection Summary',
        components: {
          default: ObjectionSummaryView
        },
        meta: {objectionView: true, enableBack: true},
      },
      {
        path: 'tama-requests/:id',
        name: 'TAMA Registration',
        components: {
          default: TamRequestForm
        },
        meta: { enableBack: true },
      },
      {
        path: 'laspppa/requests',
        name: 'LASPPPA Requests',
        components: {
          default: LaspppaRequests
        },
        meta: { taxPayerView: true },
      },
      {
        path: 'admins-settings',
        name: 'Corporate Admins Settings',
        components: {
          default: CorporateAdminSettings
        }
      },
      {
        path: 'corporate-admins',
        name: 'User Management',
        components: {
          default: CorporateAdmins
        }
      },
      {
        path: 'admins-settings',
        name: 'Corporate Admins Settings',
        components: {
          default: CorporateAdminSettings
        }
      },
      {
        path: 'payroll-paye-estimate',
        name: 'PAYE Estimate Records',
        components: {
          default: PayeEstimateRecords
        }
      },
      {
        path: 'paye-records/:recordId/estimates',
        name: 'PAYE Record Estimates',
        meta: { enableBack: true },
        components: {
          default: PayeRecordEstimates
        }
      },
      {
        path: 'paye-records/:recordId/estimates/:employeeId/details',
        name: 'PAYE Record Estimate Details',
        components: {
          default: EstimateDetails
        }
      },
    ],
    beforeEnter: (to, from, next) => {
      validateUserRoutes(to, from, next);
    }
  },
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        components: {
          default: Dashboard
        }
      },
      {
        path: 'dashboard/old',
        name: 'Dashboard Old',
        components: {
          default: DashboardOld
        }
      },
      {
        path: 'audit-trail',
        name: 'Audit Trail',
        components: {
          default: AuditTrail
        }
      },
      {
        path: 'revenue-dashboard',
        name: 'Revenue Dashboard',
        components: {
          default: EBSRCM
        }
      },
      {
        path: 'user-profile',
        name: 'Admin User Profile',
        components: {
          default: AdminProfile
        }
      },
      {
        path: 'tax-offices',
        name: 'Tax Offices',
        components: {
          default: TaxOffices
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxoffice.getall',
            'taxoffice.getone'
          ]);
        }
      },
      {
        path: 'tcc/certificates',
        name: 'TCC Certificates',
        components: {
          default: Tcc
        },
        meta: {
          requestCaptcha: false
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'tcc.getall'
          ]);
        }
      },
      {
        path: 'merge-requests',
        name: 'Merge Requests',
        components: {
          default: MergeRequests
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getall'
          ]);
        }
      },
      {
        path: 'merge-requests/:id/review',
        name: 'Merge Request',
        components: {
          default: MergeRequest
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getall'
          ]);
        }
      },
      {
        path: 'merge-requests/new',
        name: 'Merge Request Form',
        components: {
          default: MergeRequestForm
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getall'
          ]);
        }
      },
      {
        path: 'tama-requests',
        name: 'Tama Registration',
        components: {
          default: TamaRequests
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'tamarequest.getone',
            'tamarequest.getall'
          ]);
        }
      },
      {
        path: 'tama-requests/:id',
        name: 'Tama Registration',
        components: {
          default: TamaRequest
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'tamarequest.getone',
            'tamarequest.getall'
          ]);
        }
      },
      {
        path: 'tax-services',
        name: 'Tax Servcies',
        components: {
          default: TaxServices
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'taxpayer.getall'
          ]);
        }
      },
      {
        path: 'taxpayer-status-requests',
        name: 'Taxpayer Status Requests',
        components: {
          default: TaxpayerStatusUpdate
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayerstatusrequest.getone',
            'taxpayerstatusrequest.getall'
          ]);
        }
      },
      {
        path: 'users/all',
        name: 'User Management',
        components: {
          default: UserManagement
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['admin.getall', 'admin.getone']);
        }
      },
      {
        path: 'roles',
        name: 'Role Management',
        components: {
          default: RoleManagement
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['role.getall', 'role.getone']);
        }
      },
      {
        path: 'roles/:id/permissions',
        name: 'Role Permissions',
        components: {
          default: RolePermissions
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'role.getrolepermissions',
            'role.getpermissiongroups',
            'role.getpermissions'
          ]);
        }
      },
      {
        path: 'messages/direct',
        name: 'Direct Messages',
        components: {
          default: DirectMessages
        }
      },
      {
        path: 'messages/bulk',
        name: 'Bulk Messages Notification',
        components: {
          default: BulkMessages
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['admin.getall']);
        }
      },
      {
        path: 'admin-tools',
        name: 'Admin Tools',
        components: {
          default: AdminTools
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'setting.getallsettings',
            'setting.getonesetting',
            'setting.getallsettingvalues'
          ]);
        }
      },
      // {
      //   path: 'work-flows',
      //   name: 'Work Flows',
      //   components: {
      //     default: WorkFlows
      //   }
      // },
      // {
      //   path: 'work-flow/:id',
      //   name: 'Work Flow',
      //   components: {
      //     default: WorkFlow
      //   }
      // },
      {
        path: 'consultants',
        name: 'Consultants',
        components: {
          default: ConsultantsList
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultants',
            'tax_payer_manager'
          ], true);
        }
      },
      {
        path: 'consultants-tama',
        name: 'Consultants (TAMA)',
        meta: {
          isTama: true
        },
        components: {
          default: ConsultantsList
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultants',
            'tax_audit'
          ], true);
        }
      },

      {
        path: 'consultants-tama-job-requests',
        name: 'TAMA Job Requests',
        meta: {
          isTama: true
        },
        components: {
          default: ConsultantTamaJobRequests
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultants',
            'tax_audit'
          ], true);
        }
      },


      {
        path: 'create-bulk-consultants',
        name: 'Upload Bulk Consultants',
        components: {
          default: BulkConsultantsUpload
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultants',
            'tax_payer_manager'
          ], true);
        }
      },

      {
        path: 'create-bulk-consultants-tama',
        name: 'Upload Bulk Consultants TAMA',
        meta: {
          isTama: true
        },
        components: {
          default: BulkConsultantsUpload
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultants',
            'tax_audit'
          ], true);
        }
      },

      {
        path: 'consultants/:id/officers',
        name: 'Consultants Users',
        components: {
          default: ConsultantTamaUsers
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultantusers',
            'consultant.getoneconsultantuser'
          ]);
        }
      },
      {
        path: 'consultants/:id/users',
        name: 'Consultants Users',
        components: {
          default: consultantMemberListView
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultantusers',
            'consultant.getoneconsultantuser'
          ]);
        }
      },
      {
        path: 'consultants-tama/:id/users',
        name: 'Consultant TAMA Officers',
        meta: {
          isTama: true,
          enableBack: true
        },
        components: {
          default: consultantMemberListView
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultantusers',
            'consultant.getoneconsultantuser'
          ]);
        }
      },
      {
        path: 'consultants-tama/:id/assigned-cases',
        name: 'Assigned Cases',
        components: {
          default: AssignedCases
        },
        meta: { enableBack: true },
      },
      {
        path: 'consultants/:id/payers',
        name: 'Consultants Payers',
        components: {
          default: consultantPayersList
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallconsultanttaxpayers'
          ]);
        }
      },
      {
        path: 'consultants/:id/requests',
        name: 'Consultants Requests',
        components: {
          default: consultantRequestsList
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'consultant.getallrequests'
          ]);
        }
      },
      {
        path: 'relationship-management-unit',
        name: 'Relationship Management Unit (RMU)',
        components: {
          default: RelationshipManagementUnit
        }
      },
      {
        path: 'high-net-worth',
        name: 'High Networth (HN)',
        components: {
          default: HighNetWorth
        }
      },
      {
        path: 'tax-audits-team',
        name: 'Tax Audit Team',
        components: {
          default: TaxAuditTeam
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getallteams'
          ]);
        }
      },
      {
        path: 'tax-audits-team/:id',
        name: 'Tax Audit Team Details',
        components: {
          default: TaxAuditTeamDetails
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getoneteam',
            'taxaudit.getallteammembers'
          ]);
        }
      },
      {
        path: 'tax-audits-cases',
        name: 'Tax Audit Cases',
        components: {
          default: TaxAuditCases
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getall',
            'default'
          ], true);
        }
      },
      {
        path: 'tax-audits-cases/:id',
        name: 'Tax Audit Case Detail',
        components: {
          default: TaxAuditCaseDetail
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['taxaudit.getone']);
        }
      },
      {
        path: 'assigned-audit-cases',
        name: 'Assigned Audit Cases',
        components: {
          default: AssignedAuditCases
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getall',
            'assigned'
          ], true);
        }
      },

      {
        path: 'audit-case-activities/:id',
        name: 'Audit Case Activities',
        components: {
          default: AuditCaseActivityView
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getone'
          ]);
        }
      },
      {
        path: 'my-audit-cases',
        name: 'My Audit Cases',
        components: {
          default: TaxAuditCases
        }
      },
      {
        path: 'tax-audits-team-overview',
        name: 'Tax Audit Team Overview',
        components: {
          default: TaxAuditTeamOverview
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getoneteam',
            'taxaudit.getone',
            'taxaudit.getall'
          ]);
        }
      },
      {
        path: 'objections/tax-audit',
        name: 'Objections',
        meta: { isTaxAuditObjection: true },
        components: {
          default: TaxAuditObjections
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getall',
            'assigned'
          ], true);
        }
      },
      {
        path: 'objections/assessment',
        name: 'Objections',
        meta: { isAssessmentObjection: true },
        components: {
          default: TaxAuditObjections
        }
      },
      {
        path: 'flagged-objections',
        name: 'Flagged Objections',
        components: {
          default: TaxAuditObjections
        },
        meta: { isLegalPage: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getall',
            'assigned'
          ], true);
        }
      },

      {
        path: 'assigned-objections',
        name: 'Assigned Objections',
        components: {
          default: AssignedObjections
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getall',
            'assigned'
          ], true);
        }
      },

      {
        path: 'objection-activities/:id',
        name: 'Objection Activities',
        components: {
          default: ObjectionActivityView
        },
        meta: { objectionView: true, enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getone',
            'objection.getone'
          ]);
        }
      },

      {
        path: 'objection-summary/:id',
        name: 'Objection Summary',
        components: {
          default: ObjectionSummaryView
        },
        meta: { objectionView: true, enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getone',
            'objection.getone'
          ]);
        }
      },
      {
        path: 'objection-summary-assessments/:id',
        name: 'Objection Summary',
        components: {
          default: ObjectionSummaryView
        },
        meta: { isAssessmentObjection: true, enableBack: true, objectionView: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxaudit.getone',
            'objection.getone'
          ]);
        }
      },
      {
        path: 'laspppa/requests',
        name: 'LASPPPA Requests',
        components: {
          default: LaspppaRequests
        }
      },

      {
        path: 'laspppa/new-request',
        name: 'New LASPPPA Request',
        components: {
          default: LaspppaNewRequest
        },
        meta: { newRequest: true, enableBack: true }
      },

      {
        path: 'laspppa/requests/:id',
        name: 'LASPPPA Request Details',
        components: {
          default: LaspppaRequest
        },
        meta: { enableBack: true }
      },

      {
        path: 'laspppa/requests/:id/raise-assessment',
        name: 'LASPPPA Request - New Assessment',
        components: {
          default: NewAssessment
        },
        meta: { enableBack: true }
      },

      {
        path: 'tax-payers/verification',
        name: 'Tax Payer Verification',
        components: {
          default: TaxPayerVerification
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['taxpayer.getone']);
        }
      },

      {
        path: 'tax-payers/merge-taxpayer',
        name: 'Tax Payer Merge',
        beforeEnter() {
          window.open("https://lagos.ebs-rcm.com/Account/Login", '_blank');
        }
      },

      {
        path: 'tax-payers/individual',
        name: 'Individual Tax Payers',
        components: {
          default: IndividualTaxPayers
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'taxpayer.getall'
          ]);
        }
      },

      {
        path: 'tax-payers/individual/unactivated',
        name: 'Individual Tax Payers(Unactivated)',
        components: {
          default: IndividualTaxPayersUnactivated
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'taxpayer.getall'
          ]);
        }
      },
      {
        path: 'tax-payers/bulk-individual-registrations',
        name: 'Bulk Individual Registrations',
        components: {
          default: BulkIndividualRegistrations
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'taxpayer.getall'
          ]);
        }
      },
      {
        path: 'tax-payers/individual/new',
        name: 'New Taxpayer - Individual',
        components: {
          default: NewIndividualPayer
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['taxpayer.create']);
        }
      },
      {
        path: 'tax-payers/individual/:id',
        name: 'Tax Payer Profile Detail',
        components: {
          default: IndividualPayerProfilePage
        },
        meta: { enableBack: true, to: 'Individual Tax Payers' },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['taxpayer.getone']);
        }
      },
      {
        path: 'tax-payers/individual/:id/assessment/new',
        name: 'New Assessment - Individual',
        components: {
          default: NewAssessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.createassessmentgroup'
          ]);
        }
      },
      {
        path: 'tax-payers/individual/:id/assessment/:assessment_id/additional-assessment',
        name: 'Additional Assessment - Individual',
        components: {
          default: NewAssessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.getoneassessmentgroup'
          ]);
        }
      },
      {
        path: 'tax-payers/individual/:id/assessment/:assessment_id',
        name: 'Assessment - Individual',
        components: {
          default: Assessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.getoneassessmentgroup'
          ]);
        }
      },
      {
        path: 'tax-payers/individual/:id/assessment/:assessment_id/summary',
        name: 'Assessment Summary - Individual',
        components: {
          default: AssessmentSummaryIndividual
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.getoneassessmentgroup',
            'assessment.summary'
          ]);
        }
      },

      {
        path: 'tax-payers/individual/:id/tax-audits/:tax_audit_id/assessment/new',
        name: 'New Assessment - Tax Audit',
        components: {
          default: NewAssessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.createassessmentgroup'
          ]);
        }
      },

      {
        path: 'tax-payers/individual/:id/tax-audits/:tax_audit_id/assessment/:assessment_id',
        name: 'Assessment - Tax Audit',
        components: {
          default: Assessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.getoneassessmentgroup'
          ]);
        }
      },

      {
        path: 'tax-payers/corporate/:id/tax-audits/:tax_audit_id/assessment/new',
        name: 'New Assessment - Tax Audit',
        components: {
          default: NewAssessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.createassessmentgroup'
          ]);
        }
      },

      {
        path: 'tax-payers/corporate/:id/tax-audits/:tax_audit_id/assessment/:assessment_id',
        name: 'Assessment - Tax Audit',
        components: {
          default: Assessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.getoneassessmentgroup'
          ]);
        }
      },

      {
        path: 'tax-payers/corporate/:id/assessment/:assessment_id/additional-assessment',
        name: 'Additional Assessment - Corporate',
        components: {
          default: NewAssessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'assessment.getoneassessmentgroup'
          ]);
        }
      },

      {
        path: 'tax-payers/corporate',
        name: 'Corporate Tax Payers',
        components: {
          default: CorporateTaxPayers
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'taxpayer.getall'
          ]);
        }
      },
      {
        path: 'tax-payers/corporate/new',
        name: 'Register A New Corporate Tax Payer',
        components: {
          default: NewCorporatePayer
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['taxpayer.create']);
        }
      },
      {
        path: 'tax-payers/corporate/unactivated',
        name: 'Corporate Tax Payers (Unactivated)',
        components: {
          default: CorporateTaxPayersUnactivated
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'taxpayer.getall'
          ]);
        }
      },
      {
        path: 'tax-payers/corporate/:id',
        name: 'Tax Payer Profile',
        components: {
          default: CorporatePayerProfilePage
        },
        meta: { enableBack: true, to: 'Corporate Tax Payers' },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['taxpayer.getone']);
        }
      },
      {
        path: 'tax-payers/corporate/:id/returns/:returnsId/:returnType',
        name: 'Corporate Tax Payer Returns',
        components: {
          default: CorporatePayerReturnsPage
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['taxpayer.getone']);
        }
      },
      {
        path: 'tax-payers/corporate/:id/payroll/:payroll_id',
        name: 'Corporate Payroll',
        components: {
          default: Payroll
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'corporationpayroll.getonecorporatepayroll',
            'corporationpayroll.getallcorporatepayrollemployees'
          ]);
        }
      },
      {
        path: 'tax-payers/corporate/:id/assessment/new',
        name: 'New Assessment - Corporate',
        components: {
          default: NewAssessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'assessment.createassessmentgroup'
          ]);
        }
      },
      {
        path: 'tax-payers/corporate/:id/assessment/:assessment_id',
        name: 'Assessment',
        components: {
          default: Assessment
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'assessment.getoneassessmentgroup'
          ]);
        }
      },
      {
        path: 'tax-payers/corporate/:id/assessment/:assessment_id/summary',
        name: 'Assessment Summary',
        components: {
          default: AssessmentSummary
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, [
            'taxpayer.getone',
            'assessment.summary'
          ]);
        }
      },
      {
        path: 'tax-payers/advanced',
        name: 'Advanced Tax Payer Update',
        components: {
          default: AdvancedTaxPayer
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next,
            ['fe.taxpayer', 'advancedupdate'],
            true
          );
        }
      },
      {
        path: 'payments',
        name: 'Generate A New Bill',
        components: {
          default: Payment
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['bill.create', 'bill.generate']);
        }
      },
      {
        path: 'reports/debts',
        name: 'Debts Report',
        components: {
          default: Debts
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/corporate-tax-payers',
        name: "Tax Payers Report (Corporate)",
        components: {
          default: CorporateReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/directors',
        name: "Directors Report",
        components: {
          default: DirectorReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/individual-tax-payers',
        name: "Tax Payers Report (Individual)",
        components: {
          default: IndividualReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/individual-returns',
        name: 'Individual Returns Report',
        components: {
          default: ReturnsReport
        },
        meta: {
          requestCaptcha: false
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/corporate-returns',
        name: 'Corporate Returns Report',
        components: {
          default: ReturnsReport
        },
        meta: {
          requestCaptcha: false
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },

      {
        path: 'reports/corporate-horc-returns',
        name: 'Corporate HORC Returns Report',
        components: {
          default: HorcReturnsReport
        },
        meta: {
          requestCaptcha: false
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },

      {
        path: 'reports/adequacy-checks',
        name: 'Adequacy Checks',
        components: {
          default: ReturnsAdequacyChecks
        },
        meta: {
          requestCaptcha: false
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/individual-assessments',
        name: 'Individual Assessments Report',
        components: {
          default: AssessmentReport
        },
        meta: {
          requestCaptcha: false
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/corporate-assessments',
        name: 'Corporate Assessments Report',
        components: {
          default: AssessmentReport
        },
        meta: {
          requestCaptcha: false
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      { 
        path: 'reports/objections',
        name: 'Objections Report',
        components: {
          default: TaxAuditObjections
        },
        meta: {
          reports: true
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/tax-audit',
        name: 'Tax Audit Report',
        components: {
          default: TaxAuditReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/bills',
        name: 'Bills Report',
        components: {
          default: BillsReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'reports/revenue',
        name: 'Revenue Report',
        components: {
          default: RevenueReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },

      {
        path: 'ebs-reports/transactions',
        name: 'EBS Transactions Report',
        components: {
          default: EbsTransactionsReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },

      {
        path: 'ebs-reports/expatriates',
        name: 'EBS Expatriates Report',
        components: {
          default: EbsExpatriatesReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },

      {
        path: 'ebs-reports/trends',
        name: 'Trend Collection Report',
        components: {
          default: EbsTrendCollectionReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },

      {
        path: 'reports/rmu-revenue',
        name: 'RMU Revenue Report',
        components: {
          default: RmuRevenueReport
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['report.getreport']);
        }
      },
      {
        path: 'payroll-paye-estimate',
        name: 'PAYE Estimate Records',
        components: {
          default: CorporatePayeEstimateRecords
        },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['payebill.getpayrollpayeestimates']);
        }
      },

      {
        path: 'paye-records/:recordId/estimates',
        name: 'PAYE Record Estimates',
        components: {
          default: CorporatePayeRecordEstimates
        },
        meta: { enableBack: true },
        beforeEnter: (to, from, next) => {
          checkPermissions(to, from, next, ['payebill.getpayrollpayeestimates']);
        }
      },

      {
        path: 'tax-payers/corporate/:id/adequacy-check/:returns_id',
        name: 'Adequacy Check Details',
        components: {
          default: AdequacyCheck
        },
        meta: { enableBack: true }
      },
      {
        path: '/egis-geo-tagging',
        name: 'EGIS/GEO',
        components: {
          default: GeoTagging
        }
      },
      {
        path: '/assessment-modification-requests',
        name: 'Assessments/Modify State',
        components: {
          default: AssessmentRequests
        }
      },
      {
        path: 'address-change-requests',
        name: 'Address Change Requests',
        components: {
          default: AddressChangeRequests
        }
      },
      {
        path: 'address-change-requests/:id',
        name: 'Address Change Request Review',
        meta: { enableBack: true },
        components: {
          default: AddressChangeRequestReview
        }
      },

      {
        path: 'paye-records/:recordId/estimates/:employeeId/details',
        name: 'PAYE Record Estimate Details',
        components: {
          default: EstimateDetails
        }
      }
    ],
    beforeEnter: (to, from, next) => {
      validateAdminRoutes(to, from, next);
    }
  },
  {
    path: '/privacy-policy',
    redirect: '/privacy-policy',
    name: 'Privacy Policy Layout',
    component: StaticPageLayout,
    children: [
      {
        path: '/privacy-policy',
        name: 'Privacy Policy',
        components: {
          default: privacyPolicy
        }
      }
    ]
  },
];

export default routes;
